export default __webpack_public_path__ + "e965dedb16349c580eefe70c84fb9d36.png";